import { useTranslation } from "react-i18next";
import { RouteStatusAction } from "./RouteStatusAction.js";
import { RouteStatusPage } from "./RouteStatusPage.js";

/**
 * Reusable forbidden surface for routes that enforce authorization.
 * Backend permission checks remain authoritative; this only presents the outcome.
 */
export function AccessDeniedPage({ homePath = "/inbox" }: { homePath?: string }): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <RouteStatusPage
      code="403"
      title={t("routeStatus.accessDenied.title")}
      description={t("routeStatus.accessDenied.description")}
      action={<RouteStatusAction to={homePath} label={t("routeStatus.accessDenied.action")} />}
    />
  );
}
